export default __webpack_public_path__ + "static/media/rnr-sports-table-23-cn.0ae59191.webp";